//@flow

import type {ContactSummaryItem} from '../../../../entities/crm/contact';

export function contactSummaryAdapter(
  contactSummaryItem: ContactSummaryItem
): ContactSummaryItem {
  const {tags = [], ...rest} = contactSummaryItem;

  const tagsMap = new Map();

  if (tags) {
    tags.forEach(tag => {
      if (!tagsMap.has(tag.id)) {
        tagsMap.set(tag.id, tag);
      }
    });
  }

  return {
    ...rest,
    tags: Array.from(tagsMap.values()),
  };
}
